import React from "react";
import { BookOpen } from "lucide-react";
import { usePublicLang, LangToggle } from "../lib/publicLang";
import LexiconContent from "../components/LexiconContent";

const T = {
  fr: {
    title: "Lexique de l'Algorithme",
    subtitle: "Toute la terminologie — validation statistique et signaux propriétaires — expliquée simplement et techniquement.",
  },
  en: {
    title: "Algorithm Glossary",
    subtitle: "All the terminology — statistical validation and proprietary signals — explained in plain terms and technically.",
  },
};

export default function Lexique() {
  const [lang, setLang] = usePublicLang();
  const L = T[lang] || T.fr;

  return (
    <div className="p-6 max-w-5xl">
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-3">
          <BookOpen size={24} className="text-accent-blue" />
          <h1 className="font-heading font-bold text-2xl tracking-tight" data-testid="lexique-title">{L.title}</h1>
        </div>
        <LangToggle lang={lang} setLang={setLang} />
      </div>
      <p className="text-white/50 text-sm mb-6">{L.subtitle}</p>
      <LexiconContent lang={lang} />
    </div>
  );
}
